export const environment = {
  production: false,
  //API_BASE_ENDPOINT: 'http://localhost:8081',
  API_BASE_ENDPOINT: 'https://gosleep.innobyte.pe',
  KEY_PROJECT_WEB: 'AIzaSyA_KjAKWMSsheGVm9UNmuDZ84YYOB91pL0',
};
